export default __webpack_public_path__ + "static/property-img-4_1600-1cc398652cfec0c1d367011d60e165b0.jpg";